var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTincture = function SvgTincture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tincture_svg__uuid-119547b6-d16a-4535-9db3-9524f71534f7",
    width: 55,
    height: 55
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tincture_svg__uuid-65c95cd8-6a26-45db-bdfc-efc19e8119cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.83 11.5h31.33v32H11.83z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".tincture_svg__uuid-ca1960e6-ba83-479d-a352-b684a411db3b{fill:#fff;fill-rule:evenodd}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    style: {
      fill: "#061e21"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#tincture_svg__uuid-65c95cd8-6a26-45db-bdfc-efc19e8119cd)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 38.17c.21 0 .41.1.54.27.64.87 1.12 1.84 1.43 2.87l.03.19c0 .53-.21 1.04-.59 1.41a1.983 1.983 0 0 1-2.82 0c-.38-.38-.59-.88-.59-1.41 0-.07 0-.13.03-.19.31-1.03.8-2 1.43-2.87.13-.17.33-.27.54-.27M27.5 23.5c.37 0 .67.3.67.67v6a.67.67 0 0 1-1.34 0v-6c0-.37.3-.67.67-.67",
    className: "tincture_svg__uuid-ca1960e6-ba83-479d-a352-b684a411db3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.5c-1.06 0-2.08.42-2.83 1.17s-1.17 1.77-1.17 2.83v4h-2a.67.67 0 0 0 0 1.34h2v9.33c0 .78.23 1.54.65 2.19.34.53.81.96 1.35 1.27v1.87a1.333 1.333 0 0 0 1.33 1.33h1.33a1.333 1.333 0 0 0 1.33-1.33v-1.87c.54-.31 1-.75 1.35-1.27.43-.65.65-1.41.65-2.19v-9.33h2a.67.67 0 0 0 0-1.34h-2v-4a3.97 3.97 0 0 0-1.17-2.83 3.96 3.96 0 0 0-2.83-1.17Zm-2.67 9.33H23.5V19.5h1.33zm0 0h5.33v9.33c0 .52-.15 1.03-.44 1.46-.28.43-.69.78-1.16.98a.68.68 0 0 0-.4.61v2.28h-1.33v-2.28c0-.27-.16-.5-.4-.61-.48-.21-.88-.55-1.16-.98a2.7 2.7 0 0 1-.44-1.46zm0-1.33v-4c0-.71.28-1.39.78-1.89s1.18-.78 1.89-.78a2.654 2.654 0 0 1 2.47 1.65c.13.32.2.67.2 1.02v4h-5.33Z",
    className: "tincture_svg__uuid-ca1960e6-ba83-479d-a352-b684a411db3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.83h1.33V19.5H23.5z",
    style: {
      fill: "#fff"
    }
  })));
};
export default SvgTincture;